import { Form, Switch, Typography, Row, Col } from "antd";
import React from "react";
import EvaluationList from "@src/components/AIValidators/SubComponents/EvaluationList";

const { Text } = Typography;

const ValidatorForm = (form: any, disabled: boolean, evaluationResults?: any) => {
    return (
        <div style={{ paddingLeft: '0px' }}>
            <Row style={{ width: "100%" }}>
                <Col span={12}>
                    <Form.Item
                        label={<Text>Allow Auto Approval</Text>}
                        name={["extra_data", "allow_auto_approval"]}
                        valuePropName="checked"
                        labelCol={{ span: 12 }}
                        style={{ marginBottom: '8px' }}
                    >
                        <Switch disabled={disabled} />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label={<Text>Allow Auto Rejection</Text>}
                        name={["extra_data", "allow_auto_rejection"]}
                        valuePropName="checked"
                        labelCol={{ span: 12 }}
                        style={{ marginBottom: '8px' }}
                    >
                        <Switch disabled={disabled} />
                    </Form.Item>
                </Col>
            </Row>
            <Row style={{ width: "100%" }}>
                <Col span={12}>
                    <Form.Item
                        label={<Text>Send Service Info</Text>}
                        name={["extra_data", "send_service_info"]}
                        valuePropName="checked"
                        labelCol={{ span: 12 }}
                        style={{ marginBottom: '8px' }}
                    >
                        <Switch disabled={disabled} />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label={<Text>Send Existing Service Items</Text>}
                        name={["extra_data", "send_existing_service_items"]}
                        valuePropName="checked"
                        labelCol={{ span: 12 }}
                        style={{ marginBottom: '8px' }}
                    >
                        <Switch disabled={disabled} />
                    </Form.Item>
                </Col>
            </Row>

            <Form.Item name="evaluation" label="Evaluation" noStyle initialValue={[]}>
                <EvaluationList evaluationResults={evaluationResults} />
            </Form.Item>
        </div>
    );
}

export default ValidatorForm;
